export default "__VITE_ASSET__BKzXm2wY__"